import { AGENT_MEMORY_SCOPES } from './atlasMemories'
import { FilterFieldType, IFilter } from './types'

export const ATLAS_PROMPTS_FILTERS_CONFIG = [
  {
    field: 'key',
    dbField: 'key',
    alias: 'memory',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Name',
  },
  {
    field: 'description',
    dbField: 'description',
    alias: 'memory',
    type: FilterFieldType.Text,
    isSortable: false,
    title: 'Description',
  },
  {
    field: 'scope',
    dbField: 'scope',
    alias: 'memory',
    type: FilterFieldType.List,
    isSortable: true,
    isMultiple: true,
    title: 'Scope',
    options: AGENT_MEMORY_SCOPES.map((value) => ({ value, label: value })),
  },
  {
    field: 'hitCount',
    dbField: 'hit_count',
    alias: 'memory',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Use Count',
    excludeFilter: true,
    align: 'right' as const,
  },
  {
    field: 'createdAt',
    dbField: 'created_at',
    alias: 'memory',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Created',
  },
  {
    field: 'updatedAt',
    dbField: 'updated_at',
    alias: 'memory',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Last edited',
  },
] as const satisfies IFilter[]
